import BooksService from '@/common/API/BooksService';
import QuotesService from '@/common/API/QuotesService';
import { useData } from '@/common/hooks/useData';
import FormFactory from '@/components/FormFactory';
import RichEditor from '@/components/forms/RichEditor';
import Select from '@/components/forms/Select';
import { Button } from '@/components/ui/button';
import { Field } from 'formik';
import React, { MutableRefObject, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';

const QuotesEditForm = () => {
  const formRef: MutableRefObject<any> = useRef();
  const { tags, books } = useData();
  const { quoteId } = useParams<{ quoteId: any }>();
  const [quoteData, setQuoteData] = useState<any>(null);

  useEffect(() => {
    QuotesService.one(quoteId).then((res: any) => {
      setQuoteData(res.data);
    });
  }, []);

  if (!quoteData) return <h1>Loading</h1>;

  return (
    <>
      <FormFactory
        formRef={formRef}
        initialValues={{ text: quoteData?.text, tag_id: quoteData?.tag?.id, book_id: quoteData?.book?.id }}
      >
        <div style={{ height: '84vh' }} className='grid grid-rows-12'>
          <Field name='tag_id' options={tags} placeholder='Select tag' component={Select} />
          <Field name='book_id' options={books} placeholder='Select book' component={Select} />
          <Field
            className='row-span-9 h-full'
            name='text'
            placeholder='Author name'
            component={RichEditor}
            defaultContent={quoteData?.text}
          />
          <div className='row-span-1 flex items-end'>
            <Button
              onClick={() => {
                console.log(formRef.current.values);
                QuotesService.update(quoteId, formRef.current.values).then((res) => {
                  console.log('DODATO');
                });
              }}
              className='w-full'
            >
              Save
            </Button>
          </div>
        </div>
      </FormFactory>
    </>
  );
};

export default QuotesEditForm;
